export class StatusItem {
    name: string; // 'slogans' 'banners_and_images' - this helps us relate alerts to status, for example HubManagementAlerts
    translationKey : string // "common.contact_people"
    text? : string // "Contact people"
    type?: string // ICONS. null type and null status mean simple bullets; or type could be 'check', 'warning', 'info', 'cancel' 'status' means icons like tick, cross, warning-sign, info etc
    status?: string // COLOURS 'status' means 'success','info','warning' and 'danger' which convert to ng-valid, ng-info, ng-warning, ng-invalid in the CSSS
  }